<template>
  <nav v-if="normalizedTotalPages > 1" class="app-pagination" aria-label="Paginacion">
    <ul class="pagination pagination-sm app-table-pagination app-pagination__list">
      <li class="page-item" :class="{ disabled: normalizedCurrentPage <= 1 }">
        <button
          type="button"
          class="page-link"
          @click="emitPage(normalizedCurrentPage - 1)"
        >
          Anterior
        </button>
      </li>

      <li
        v-for="page in pagesToShow"
        :key="`page-${page}`"
        class="page-item"
        :class="{ active: normalizedCurrentPage === page }"
      >
        <button
          type="button"
          class="page-link"
          @click="emitPage(page)"
        >
          {{ page }}
        </button>
      </li>

      <li class="page-item" :class="{ disabled: normalizedCurrentPage >= normalizedTotalPages }">
        <button
          type="button"
          class="page-link"
          @click="emitPage(normalizedCurrentPage + 1)"
        >
          Siguiente
        </button>
      </li>
    </ul>
  </nav>
</template>

<script>
import { ensureValidPage } from '@/composables/shared/usePagination';

export default {
  name: 'AppPagination',
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
    totalPages: {
      type: Number,
      default: 1,
    },
    maxVisible: {
      type: Number,
      default: 5,
    },
  },
  emits: ['page-change'],
  computed: {
    normalizedCurrentPage() {
      return ensureValidPage(this.currentPage, this.normalizedTotalPages);
    },
    normalizedTotalPages() {
      const totalPages = Number(this.totalPages || 1);
      return totalPages > 0 ? totalPages : 1;
    },
    pagesToShow() {
      const totalPages = this.normalizedTotalPages;
      const currentPage = this.normalizedCurrentPage;
      const maxVisible = Math.max(3, Number(this.maxVisible || 5));
      const half = Math.floor(maxVisible / 2);

      let start = Math.max(1, currentPage - half);
      let end = Math.min(totalPages, start + maxVisible - 1);

      if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1);
      }

      const pages = [];
      for (let page = start; page <= end; page += 1) {
        pages.push(page);
      }

      return pages;
    },
  },
  methods: {
    emitPage(page) {
      const nextPage = Number(page || 1);

      if (!Number.isFinite(nextPage)) {
        return;
      }

      if (nextPage < 1 || nextPage > this.normalizedTotalPages) {
        return;
      }

      if (nextPage === this.normalizedCurrentPage) {
        return;
      }

      this.$emit('page-change', nextPage);
    },
  },
};
</script>
